import { SourceType } from 'module/api/filter/types';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { useGetAllSignalFieldsQuery } from 'queries/fields';
import { useMemo } from 'react';
import { useReasonFieldOptions } from './reason-options';

export const useSignalCustomFieldsAsFilterableFields = () => {
  const { data: signalFields, isLoading: signalFieldsLoading } =
    useGetAllSignalFieldsQuery();
  const { options: reasonOptions, isLoading: reasonOptionsLoading } =
    useReasonFieldOptions();

  return useMemo(
    () => ({
      loading: signalFieldsLoading || reasonOptionsLoading,
      fields: (signalFields ?? []).map((field) => {
        const isReasonField = field.fieldName === 'Reason';

        return {
          ...field,
          type: filterableFieldType(field),
          sourceType: SourceType.Signal,
          customField: true,
          userCreated: true,
          ...(isReasonField && {
            metaData: {
              ...field.metaData,
              options: reasonOptions,
            },
          }),
        };
      }) as FilterableField[],
    }),
    [signalFields, signalFieldsLoading, reasonOptions, reasonOptionsLoading],
  );
};
